// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--shn-style-controller{
    width: 100%;
    height: auto;
    border-bottom: 1px solid rgba(225, 228, 237, 1);
}

.scl--arr-const-styl-box{
    display: flex;
    gap: 30px;
    height: 100%;
}

.scl--btn-shn-sty-const{
    height: 100%;
}

.scl--btn-shn-sty-const.active{
    border-bottom: 2px solid rgba(35, 136, 255, 1);
}

.scl--inner-btn-shn-styl-const{
    min-height: 28px;
    border: none;
    background: transparent;
    font-family: var(--font-family-inter);
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-weight: 500;
    color: var(--typography-text-body-secondary);
    display: flex;
    cursor: pointer;
}

.scl--inner-btn-shn-styl-const.active{
    color: var(--primarypalette-blue);
}`, "",{"version":3,"sources":["webpack://./src/layout-controller-mod/layout-serv/header/css/settingHeadNav.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,qCAAqC;IACrC,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,4CAA4C;IAC5C,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,iCAAiC;AACrC","sourcesContent":[".scl--shn-style-controller{\n    width: 100%;\n    height: auto;\n    border-bottom: 1px solid rgba(225, 228, 237, 1);\n}\n\n.scl--arr-const-styl-box{\n    display: flex;\n    gap: 30px;\n    height: 100%;\n}\n\n.scl--btn-shn-sty-const{\n    height: 100%;\n}\n\n.scl--btn-shn-sty-const.active{\n    border-bottom: 2px solid rgba(35, 136, 255, 1);\n}\n\n.scl--inner-btn-shn-styl-const{\n    min-height: 28px;\n    border: none;\n    background: transparent;\n    font-family: var(--font-family-inter);\n    margin: 0;\n    padding: 0;\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--typography-text-body-secondary);\n    display: flex;\n    cursor: pointer;\n}\n\n.scl--inner-btn-shn-styl-const.active{\n    color: var(--primarypalette-blue);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
